import { render, staticRenderFns } from "./OrderHistoryRow.vue?vue&type=template&id=4b868d34"
import script from "./OrderHistoryRow.vue?vue&type=script&lang=js"
export * from "./OrderHistoryRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports